var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { getTrackerProps, getCMSTrackerProps, } from '../../common/tracking/getTrackerProps';
import { display, fontSize, lineHeight, fontWeight, space, justifyContent, maxWidth, overflow, themeGet, } from 'styled-system';
import { modifiers as themeModifiers } from '../../common/theme/helper';
import { Link } from '../../common/components/Link';
import { ItemShape } from '../../common/prop-types/NavigationItem';
import { LazyImage } from '../../common/components/LazyImage';
var Dropdown = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  display: ", ";\n  position: absolute;\n  z-index: 999;\n  top: calc(100% - 4px);\n  left: -", "px;\n  width: calc(100% + ", "px);\n  box-shadow: 0 2px 3.5px 0.5px rgba(0, 0, 0, 0.09);\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-sizing: border-box;\n"], ["\n  ", ";\n  display: ", ";\n  position: absolute;\n  z-index: 999;\n  top: calc(100% - 4px);\n  left: -", "px;\n  width: calc(100% + ", "px);\n  box-shadow: 0 2px 3.5px 0.5px rgba(0, 0, 0, 0.09);\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-sizing: border-box;\n"])), space, function (props) { return (props.focused ? 'block' : 'none'); }, themeGet('space.4'), themeGet('space.6'), themeGet('colors.gray.5'), themeGet('colors.gray.0'));
Dropdown.defaultProps = {
    p: 4,
};
var DropdownContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, justifyContent);
DropdownContent.defaultProps = {
    display: 'flex',
    justifyContent: 'start',
};
Dropdown.propTypes = {
    focused: PropTypes.bool,
};
var PromoImageContainer = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  filter: ", ";\n"], ["\n  ", ";\n  ", ";\n  filter: ", ";\n"])), display, fontSize, function (props) { return (props.imgLoaded ? 'none' : 'blur(4px)'); });
PromoImageContainer.defaultProps = {
    display: 'block',
    fontSize: 0,
};
var PromoImage = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: auto;\n"], ["\n  width: 100%;\n  height: auto;\n"])));
var Level2Column = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  /* (100% - Dropdown padding-left + padding-right) / number-of-columns */\n  width: calc((100% - ", "px) / 5);\n  box-sizing: content-box;\n\n  &:not(:first-of-type) {\n    ", ";\n  }\n"], ["\n  /* (100% - Dropdown padding-left + padding-right) / number-of-columns */\n  width: calc((100% - ", "px) / 5);\n  box-sizing: content-box;\n\n  &:not(:first-of-type) {\n    ", ";\n  }\n"])), themeGet('space.6'), space);
Level2Column.defaultProps = {
    pl: ['12px', null, null, 4],
};
var Level2Heading = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:not(:last-child) {\n    ", ";\n  }\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:not(:last-child) {\n    ", ";\n  }\n\n  ", ";\n"])), fontSize, lineHeight, fontWeight, display, space, themeModifiers);
Level2Heading.defaultProps = {
    fontSize: [3, null, null, 4],
    lineHeight: [2, null, null, 3],
    fontWeight: 'bold',
    display: 'block',
    mb: 2,
};
var Level2CMSBlock = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), space, maxWidth, overflow);
Level2CMSBlock.defaultProps = {
    my: 0,
    mx: 'auto',
    maxWidth: '100%',
    overflow: 'hidden',
};
var Level2Item = function (_a) {
    var level1Name = _a.level1Name, name = _a.name, href = _a.href, modifiers = _a.modifiers, html = _a.html, listIndex = _a.listIndex, listLength = _a.listLength;
    if (html) {
        return (React.createElement(Level2CMSBlock, __assign({}, getCMSTrackerProps({
            dangerouslySetInnerHTML: { __html: html },
        }, {
            event: 'navigation',
            eventData: {
                placement: 'primaryNavigation',
                navPath: [level1Name],
            },
        }, ['A', 'IMG']))));
    }
    if (name) {
        return href ? (React.createElement(Level2Heading, __assign({}, getTrackerProps({
            href: href,
            modifiers: modifiers,
            as: Link,
        }, {
            event: 'navigation',
            eventData: {
                placement: 'primaryNavigation',
                currentNavLevel: null,
                destinationNavLevel: 2,
                navPath: [level1Name, name],
                listIndex: listIndex,
                listLength: listLength,
            },
        })), name)) : (React.createElement(Level2Heading, { modifiers: modifiers }, name));
    }
    return null;
};
Level2Item.propTypes = ItemShape;
var Level2ItemPromoImg = function (_a) {
    var _b = _a.promoImg, alt = _b.alt, href = _b.href, imgData = __rest(_b, ["alt", "href"]);
    return (React.createElement(LazyImage, __assign({}, imgData), function (_a) {
        var loaded = _a.loaded, image = _a.image, thumbnail = _a.thumbnail, innerRef = _a.innerRef;
        return (React.createElement(PromoImageContainer, { href: href, imgLoaded: loaded },
            React.createElement(PromoImage, { alt: alt, ref: innerRef, src: loaded ? image : thumbnail })));
    }));
};
Level2ItemPromoImg.propTypes = {
    promoImg: ItemShape.promoImg.isRequired,
};
var Level3Group = styled.ul(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  &:not(:last-child) {\n    ", ";\n  }\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  &:not(:last-child) {\n    ", ";\n  }\n"])), space);
Level3Group.defaultProps = {
    pb: 4,
};
var Level3Item = styled.li(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  &:not(:last-child) {\n    ", ";\n  }\n"], ["\n  &:not(:last-child) {\n    ", ";\n  }\n"])), space);
Level3Item.defaultProps = {
    mb: 2,
};
var Level3Link = styled(Link)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), fontSize, lineHeight, themeModifiers);
Level3Link.defaultProps = __assign({}, Link.defaultProps, { fontSize: [3, null, null, 4], lineHeight: [2, null, null, 3] });
var NavigationDropdown = function (_a) {
    var level1Name = _a.level1Name, items = _a.items, focused = _a.focused;
    // A lot of work happening only once, let's memoize it
    var columns = useMemo(function () {
        var e_1, _a;
        // We will re-distribute the columns based on the new GN logic:
        //   - Always 5 columns, last one is always a promo block with an image
        //
        // This will flatten the items no matter if they are coming from the props
        // in columns (old GN behaviour) or not
        var flat = items.reduce(function (el, item) { return el.concat(item); }, []);
        // Create an empty list of 5 items to represent all the columns on the screen
        var cols = new Array(5).fill(null);
        // Find a promo block in a flatten items
        var promo = flat.find(function (item) { return item.html || item.promoImg; });
        // Set CMS block in the last column if exists
        if (promo) {
            cols[4] = [promo];
        }
        try {
            for (var _b = __values(flat.filter(function (el) { return el !== promo; }).entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), index = _d[0], item = _d[1];
                // Get the column index where to put the navigation item
                var columnIndex = index % 4;
                if (!Array.isArray(cols[columnIndex])) {
                    cols[columnIndex] = [];
                }
                // Add it to the column at appropriate index
                cols[columnIndex].push(item);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return cols;
    }, [items]);
    return (React.createElement(Dropdown, { focused: focused, "aria-hidden": !focused, "data-testid": "dropdown" },
        React.createElement(DropdownContent, null, columns.map(function (column, colIdx) { return (React.createElement(Level2Column, { key: colIdx }, column &&
            Array.isArray(column) &&
            column.map(function (_a, cellIdx) {
                var name = _a.name, href = _a.href, modifiers = _a.modifiers, html = _a.html, promoImg = _a.promoImg, children = _a.children;
                var isNested = !!(children && children.length > 0);
                var level2Name = name;
                return (React.createElement(Fragment, { key: cellIdx },
                    promoImg ? (React.createElement(Level2ItemPromoImg, { promoImg: promoImg })) : (React.createElement(Level2Item, { level1Name: level1Name, name: name, href: href, modifiers: modifiers, html: html, listIndex: cellIdx, listLength: column.length })),
                    isNested &&
                        children.map(function (group, idx) { return (React.createElement(Level3Group, { key: idx }, group.map(function (_a) {
                            var itemName = _a.name, itemHref = _a.href, itemModifiers = _a.modifiers;
                            return (React.createElement(Level3Item, { key: itemName },
                                React.createElement(Level3Link, __assign({}, getTrackerProps({
                                    href: itemHref,
                                    modifiers: itemModifiers,
                                }, {
                                    event: 'navigation',
                                    eventData: {
                                        placement: 'primaryNavigation',
                                        currentNavLevel: null,
                                        destinationNavLevel: 3,
                                        navPath: [
                                            level1Name,
                                            level2Name,
                                            itemName,
                                        ],
                                        listIndex: idx,
                                        listLength: children.length,
                                    },
                                })), itemName)));
                        }))); })));
            }))); }))));
};
NavigationDropdown.propTypes = {
    level1Name: PropTypes.string,
    focused: PropTypes.bool,
    items: ItemShape.children.isRequired,
};
export default NavigationDropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
